module.exports = __webpack_public_path__ + "img/boltEmpty.6c082a1c.svg";